/**
 * Helpers shared across drift checker pure functions.
 *
 * These are file-IO and string utilities that more than one checker needs.
 * They live here (not in `registry.ts`) because they are used inside the
 * checker's pure function, not inside a declaration.
 */
import { readFileSync } from "node:fs";

/** Default per-file read cap — scaffold docs are prose, not data dumps. */
export const DEFAULT_SCAFFOLD_CAP = 15_000;

/**
 * Read a file and cap it to `maxChars`. Returns null on any read failure so
 * callers can choose to skip (`continue`) or substitute empty text.
 */
export function readCapped(file: string, maxChars = DEFAULT_SCAFFOLD_CAP): string | null {
  try {
    const raw = readFileSync(file, "utf-8");
    return raw.length > maxChars ? raw.slice(0, maxChars) : raw;
  } catch {
    return null;
  }
}

/**
 * Concatenate the (capped) text of several scaffold files into one searchable
 * blob. Unreadable files contribute an empty string.
 */
export function loadScaffoldText(files: readonly string[], maxChars = DEFAULT_SCAFFOLD_CAP): string {
  return files.map((f) => readCapped(f, maxChars) ?? "").join("\n");
}